import { cronosClient } from "@/config/client"

export type ActivityStatus = "pending" | "rescheduled" | "approved" | "skipped" | "failed"

interface UpdateActivityData {
  status?: ActivityStatus
  dateTime?: string
}

export function update(id: string, data: UpdateActivityData) {
  return cronosClient.put<void, UpdateActivityData>(`/v1/activities/${id}/user-values`, data)
}
